/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentPackage = {
  /**
   * The ID of the deployment package.
   */
  id: string;
  /**
   * The name of the package.
   */
  name: string;
  /**
   * The version of the package.
   */
  version: string;
};

/** @internal */
export const DeploymentPackage$inboundSchema: z.ZodMiniType<
  DeploymentPackage,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
  version: z.string(),
});

export function deploymentPackageFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentPackage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentPackage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentPackage' from JSON`,
  );
}
